import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import TestimonialsSection from './components/TestimonialsSection';
import HowItWorks from './components/HowItWorks';
import GalleryPricing from './components/GalleryPricing';
import BookingCTA from './components/BookingCTA';
import Footer from './components/Footer';

export default function Home() {
  return (
    <main className="font-sans bg-white overflow-x-hidden">
      <Navbar />
      <HeroSection />
      <FeaturesSection />
      <TestimonialsSection />
      <HowItWorks />
      <GalleryPricing />
      <BookingCTA />
      <Footer />
    </main>
  );
}